import React from 'react';
import PropTypes from 'prop-types';

import { Cell, DropdownToggleIcon, Text } from '../../atoms';

const DropdownMenuToggle = ({
  text = null,
  isOpen = false,
  onClick = null,
  leftIcon = null,
  className = ''
}) => (
  <Cell onClick={onClick} className={className}>
    {leftIcon}
    <Text>{text}</Text>
    <DropdownToggleIcon
      $isOpen={isOpen}
      name='chevron-down'
      displaySize={16}
      color='var(--content-body)'
    />
  </Cell>
);

DropdownMenuToggle.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  leftIcon: PropTypes.node,
  className: PropTypes.string
};

export { DropdownMenuToggle };
